import messages from './GLTooltip.message';

const Tooltips = {
    GL7CyberSuiteCov_Ext: messages.GL7CyberSuiteCov_Ext
}

export default Tooltips